// extracted by mini-css-extract-plugin
export var container = "_bq-0";
export var icon = "_bq-1";
export var text = "_bq-2";